import { HttpService } from '@/shared/api/services/HttpService';
import { buildUrlForServiceName } from '@/connection/url-retriever';
import conf from '@/shared/config/useConfig';
import type { Kautionsvertrag, KautionsvertragVereinfacht } from '@/types/Vertrag.ts';
import type { FilterOptionen } from '@/components/datatable/types/FilterObject.ts';
import type {
  VertragFilter,
  VertragFilterOptionenParams,
  VertragFilterResponse,
} from '@/connection/filter-helper/filter-helper-verträge.ts';

export class SharedKreditvertragService extends HttpService {
  protected baseUrl = `${buildUrlForServiceName(conf.partnerserviceName)}/partnerservice/api/private/v2/kautionsvertraege`;

  async holeKautionsvertrag(kautionsvertragId: number): Promise<Kautionsvertrag> {
    return this.httpClient.get(`${this.baseUrl}/${kautionsvertragId}`);
  }

  async holeKautionsvertragVereinfacht(
    kautionsvertragId: number,
  ): Promise<KautionsvertragVereinfacht> {
    return this.httpClient.get(`${this.baseUrl}/${kautionsvertragId}/summary`);
  }

  async holeFilterOptionenVertraege(params: VertragFilterOptionenParams): Promise<FilterOptionen> {
    return this.httpClient.post(`${this.baseUrl}/filteroptionen`, {
      params: params as Record<string, unknown>,
    });
  }

  async holeVertraegeMitPaginierungUndFilterung(
    seite: number,
    seitengroesse: number,
    property: string,
    sortierArt: string,
    vertragFilter: VertragFilter,
  ): Promise<VertragFilterResponse> {
    return this.httpClient.post(`${this.baseUrl}/filterung`, {
      data: vertragFilter,
      params: { page: seite, size: seitengroesse, sort: `${property},${sortierArt}` },
    });
  }
}
